export const FETCH_INSTANCE_STARTED = 'FETCH_INSTANCE_STARTED' as const;
export const FETCH_INSTANCE_FULFILLED = 'FETCH_INSTANCE_FULFILLED' as const;

export const fetchInstance = () => ({ type: FETCH_INSTANCE_STARTED });

export const fetchInstancefulfilled = (data: unknown) => ({ type: FETCH_INSTANCE_FULFILLED, payload: data });
